"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { LocaleType } from "./types";

const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

export const useChangeLocale = () => {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const changeLocale = (locale: LocaleType) => {
    document.cookie = `NEXT_LOCALE=${locale}; path=/; max-age=${ONE_YEAR_IN_SECONDS}; samesite=lax`;

    startTransition(() => {
      router.refresh();
    });
  };

  return {
    changeLocale,
    isPending,
  };
};
